<template>
<div>
      <el-form  label-width="120px">
            <el-row>
                <el-col :lg="8">
                          <el-form-item label="品牌:">
                            {{this.brand}}
                           </el-form-item>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="店櫃代碼:">
                        {{this.shopinfo.shop_id}}
                    </el-form-item>
                </el-col>
                <el-col :lg="8">
                    <el-form-item label="店櫃名稱:">
                        <el-input v-model="shopinfo.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="店櫃電話:">
                        <el-input v-model="shopinfo.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8">
                    <el-form-item label="店櫃傳真:">
                        <el-input v-model="shopinfo.fax"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-row>
                <el-col :lg="8">
                    <el-form-item label="區域:">
                        <el-input v-model="shopinfo.area_note"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
            <el-row style="margin: 20px;">
                <el-col :lg="8">
                    <el-form-item label="平板設備ID:" >
                        <el-input v-model="device" style="width:70%;"></el-input>
                          <el-button type="primary" @click="addDevice">加入</el-button>
                    </el-form-item>
                  
                </el-col>
                <el-col :lg="8">
                     <el-table
                               :data="devices"
                               style="width: 100%"
                               size="small"
                               border
                               >
                               <el-table-column
                               
                                     prop="device_id"                       
                                   label="平板設備ID"
                                   width="auto"
                                   header-align="center"
                                   align="center">
                               
                               </el-table-column>
                               <el-table-column label="刪除" align="center">
                                   <template slot-scope="scope">
                                       <el-button type="danger" icon="el-icon-delete" @click.native.prevent="deleteDevice(scope.$index, devices)"></el-button>
                                   </template>
                               </el-table-column>
                           </el-table>
                </el-col>
            </el-row>
            <el-row style="margin:20px;">
                <el-col :lg="24">
                    <el-form-item label="地址:" >
                               <el-select v-model="shopinfo.city" placeholder="" @change="queryArea" >
                               <el-option v-for="item in getCityItems"
                                   :key="item.city"
                                   :label="item.city"
                                   :value="item.city">
                               </el-option>
                           </el-select>
                           <el-select v-model="shopinfo.area" placeholder="" >
                               <el-option v-for="item in getAreaItems"
                                   :key="item.area"
                                   :label="item.area"
                                   :value="item.area">
                               </el-option>
                           </el-select>
                           
                               <el-input v-model="shopinfo.address" style="width:50%;"></el-input>
                           
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="16">
                   <el-form-item label="簡介:">
                        <el-input type="textarea" v-model="shopinfo.note" size="small" :rows="7"></el-input>
                   </el-form-item>
                </el-col>
              
            </el-row>
            <el-row type="flex" align="center">
                <el-col :lg="8">
                    <el-button type="primary" @click="updateShop"><i class="el-icon-edit"></i>修改</el-button>
                    
                    <el-button type="default" @click="back">返回</el-button>
                </el-col>
                <el-col :lg="8"></el-col>
            </el-row>
            
        </el-form>
        
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Edit',
        props:{
            shopKey: String
        },
        data() {
            return {
                shopinfo:{},
                device: '',
                devices: [],
                brand: ''
            }
        },
         computed: 
            mapGetters(["getShopDetail", "getCityItems", "getAreaItems"]),
        
        methods: {
            ...mapActions(["fetchShopDetail", "fetchCity", "fetchArea", "updateShop"]),
            fetch: function () {
                const shopKey = {_key: this.shopKey}
                this.$store.dispatch('fetchShopDetail', shopKey)
                .then(() => {
                    this.shopinfo = this.getShopDetail
                   this.devices = this.getShopDetail.device_id
                    if (this.shopinfo.brand_id == 1) {
                        this.brand = "N牌"
                    }else  {
                        this.brand = "S牌"
                    }
                    
                }).catch((err) => {
                    console.log(err);
                });
            },
             fetchCity(){
             this.$store.dispatch('fetchCity')
             this.queryArea(this.getShopDetail.city)
         },
               queryArea: function(city){
                   
          let cityName = {city}
          this.$store.dispatch('fetchArea', cityName )
         },
         addDevice: function(){
             this.devices.push({
                 device_id: this.device
             })
             this.device = ''
         },
         async updateShop() {
             const data = {
                 _key: this.shopinfo._key,
                  name: this.shopinfo.name,
                  tel: this.shopinfo.tel,
                  fax: this.shopinfo.fax,
                  area_note: this.shopinfo.area_note,
                  city: this.shopinfo.city,
                  area: this.shopinfo.area,
                  address: this.shopinfo.address,
                  device_id: this.devices,
                  note: this.shopinfo.note
             }
             await this.$store.dispatch('updateShop', data)
                
             .then(() => {
                 this.$emit('removeEdit')
             }).catch((err) => {
                 console.log(err)
             });
         },
         back: function(){
             this.$emit('back')
         },
          deleteDevice(index, rows){
             rows.splice(index, 1)
         }
        
        },
        created() {
            this.fetch()
            this.fetchCity()
            
        },

    }
</script>

<style lang="scss" scoped>
    
</style>